import Events from '@/events'
import {getDiverRealtimeGps} from "@/api/realtimeGps";
import BaseCache from "./cache/base-cache"
import {BaseDataCenter} from "./base-data-center";

class DriverGPSService extends BaseDataCenter {
  constructor(rootVue) {
    super('driverGPSService', DriverGPSService);

    this._rootVue = rootVue
    this._listCache = new BaseCache({
      func: getDiverRealtimeGps,
      events: [Events.EDIT_DRIVER_GPS, Events.DELETE_DRIVER, Events.NEW_DRIVER],
      formatResult: true,
    })
    this._list_waiting = {main: null};
    this._list_running = false;
    this._initWatchItem([Events.EDIT_DRIVER_GPS]);
    this._initWatchList([Events.EDIT_DRIVER_GPS, Events.DELETE_DRIVER, Events.NEW_DRIVER]);
  }

  getList(data) {
    this._listCache._clear()
    if (this._list_running) {
      if (!this._list_waiting.main) {
        this._list_waiting.main = new Promise((resolve, reject) => {
          this._list_waiting.resolve = resolve;
          this._list_waiting.reject = reject;
        })
      }
      return Object.assign({isHit: this._listCache.isHit(data), data: this._list_waiting.main})
    }
    const r1 = this._listCache.getData(data);
    this._list_running = true;
    return Object.assign({}, r1, {data: new Promise((resolve, reject) => {
        r1.data.then(res => {
          resolve(res)
          if (this._list_waiting.main) {
            this._list_waiting.resolve(res)
          }
        }).catch(res => {
          reject(res)
          if (this._list_waiting.main) {
            this._list_waiting.reject(res)
          }
        }).finally(() => {
          this._list_waiting.main = null;
          this._list_running = false
        })
      })})
  }

  getItem(id) {
    this._listCache._clear()
    return this._listCache.getData({driverId: [id]})
  }

  getItems(ids) {
    this._listCache._clear()
    return this._listCache.getData({driverId: ids})
  }
}

let instance = null

export function driverGPSServerInit($bus) {
  console.debug('driverGPSServerInit')
  if(!instance) {
    instance = new DriverGPSService($bus)
  }
}

export function getDriverGPSServerInstance() {
  return instance
}

